// extracted by mini-css-extract-plugin
export var columnWrap = "columns-module--column-wrap--LrGWf";
export var halfColumns = "columns-module--half-columns--1A3VT";